<script setup lang="ts">
import { inject, watchEffect, onBeforeUnmount } from 'vue';
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';
import { VtkViewContext } from '@/src/components/vtk/context';
import { useDentalMeshStore } from './meshStore';
import { useDentalSceneStore } from './sceneStore';
import { observeActor } from './actorObservation';
const view = inject(VtkViewContext); if (!view) throw new Error('A vtk view is required.');
const mesh = useDentalMeshStore(); const scene = useDentalSceneStore();
const mapper = vtkMapper.newInstance({ scalarVisibility: false }); const actor = vtkActor.newInstance(); actor.setMapper(mapper);
actor.setPickable(false); actor.setUseBounds(false); actor.getProperty().setColor(0.65, 0.7, 0.8); actor.getProperty().setOpacity(0.4); actor.getProperty().setRepresentationToWireframe();
view.renderer.addActor(actor); const remove = observeActor(actor, view.renderer, { kind: 'registration-original' });
watchEffect(() => { if (mesh.mesh) mapper.setInputData(mesh.mesh); actor.setVisibility(!!mesh.mesh && scene.originalVisible); view!.requestRender(); });
onBeforeUnmount(() => { remove(); view!.renderer.removeActor(actor); actor.delete(); mapper.delete(); });
</script>
<template><slot /></template>
